// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__gJSx2","header":"styles_header__j4NDG"};